import React, { useEffect } from "react";
import s from "./style.module.scss";
import PropTypes from "prop-types";
import QuestionPreview from "../QuestionPreview";
import { useSelector } from "react-redux";
import {
  THEME_GLOBAL_TECHNOLOGY,
  THEME_WALMART_CLASSIC,
  THEME_SAM_CLUB,
  THEME_INTERNATIONAL,
} from "../../constants";

import globalTech1 from "../../../images/emoticons/globalTech1.svg";
import globalTech2 from "../../../images/emoticons/globalTech2.svg";
import globalTech3 from "../../../images/emoticons/globalTech3.svg";
import globalTech4 from "../../../images/emoticons/globalTech4.svg";
import globalTech5 from "../../../images/emoticons/globalTech5.svg";

import classicInternational1 from "../../../images/emoticons/classicInternational1.svg";
import classicInternational2 from "../../../images/emoticons/classicInternational2.svg";
import classicInternational3 from "../../../images/emoticons/classicInternational3.svg";
import classicInternational4 from "../../../images/emoticons/classicInternational4.svg";
import classicInternational5 from "../../../images/emoticons/classicInternational5.svg";

import sam1 from "../../../images/emoticons/sam1.svg";
import sam2 from "../../../images/emoticons/sam2.svg";
import sam3 from "../../../images/emoticons/sam3.svg";
import sam4 from "../../../images/emoticons/sam4.svg";
import sam5 from "../../../images/emoticons/sam5.svg";

import smileOff1 from "../../../images/emoticons/smile1.jpg";
import smileOff2 from "../../../images/emoticons/smile2.jpg";
import smileOff3 from "../../../images/emoticons/smile3.jpg";
import smileOff4 from "../../../images/emoticons/smile4.jpg";
import smileOff5 from "../../../images/emoticons/smile5.jpg";
import { extractContent } from "../../../services/commons";
import { getTranslation } from "../../../locales";

const smileObj = {
  [THEME_SAM_CLUB]: [sam1, sam2, sam3, sam4, sam5],
  [THEME_WALMART_CLASSIC]: [
    classicInternational1,
    classicInternational2,
    classicInternational3,
    classicInternational4,
    classicInternational5,
  ],
  [THEME_INTERNATIONAL]: [
    classicInternational1,
    classicInternational2,
    classicInternational3,
    classicInternational4,
    classicInternational5,
  ],
  [THEME_GLOBAL_TECHNOLOGY]: [
    globalTech1,
    globalTech2,
    globalTech3,
    globalTech4,
    globalTech5,
  ],
};
const off = [smileOff1, smileOff2, smileOff3, smileOff4, smileOff5];

const AnswerSatisfactionFaces = (props) => {
  const [value, setValue] = React.useState(props.value);
  const [themeSmilies, setThemeSmilies] = React.useState([
    ...smileObj[THEME_GLOBAL_TECHNOLOGY],
  ]);
  const [allSmilies, setAllSmilies] = React.useState([...off]);

  const { survey } = useSelector((state) => state);

  useEffect(() => {
    const { currentSurveyId } = survey;
    if (currentSurveyId) {
      const { thirdPartySettings } = survey.data[currentSurveyId];
      if (
        thirdPartySettings &&
        thirdPartySettings.theme &&
        Object.prototype.hasOwnProperty.call(smileObj, thirdPartySettings.theme)
      ) {
        setThemeSmilies(smileObj[thirdPartySettings.theme]);

        if (props.value >= 0) {
          const offValues = [...off];
          offValues[props.value] =
            smileObj[thirdPartySettings.theme][props.value];
          setAllSmilies(offValues);
          setValue(props.value);
        }
      }
    }
  }, [JSON.stringify(survey.data), props.value]);

  const handleChangeFace = (index) => {
    const offValues = [...off];
    offValues[index] = themeSmilies[index];

    setAllSmilies(offValues);
    setValue(index);
    props.handleChange(index + 1);
  };

  const renderAltText = (index) => {
    switch (index) {
      case 0:
        return "Strongly Dissatisfied";
      case 1:
        return "Dissatisfied";
      case 2:
        return "Neutral";
      case 3:
        return "Satisfied";
      case 4:
        return "Strongly Satisfied";
      default:
        break;
    }
  };

  return (
    <div>
      <fieldset aria-required={props.required}>
        <legend>
          <QuestionPreview
            question={props.question}
            required={props.required}
            helperText={props.helperText}
          />
        </legend>
        <div className={s.container}>
          {allSmilies.map((val, index) => (
            <label
              htmlFor={`${index}-${props.question}`}
              key={`${index}-${props.question}`}
              className={s.labelStyle}
            >
              <input
                aria-label={renderAltText(index)}
                type="radio"
                value={value}
                name={`${extractContent(props.question.replace(/\s+/g, ""))}`}
                id={`${index}-${extractContent(
                  props.question.replace(/\s+/g, "")
                )}`}
                key={index}
                onClick={() => handleChangeFace(index)}
                className={s.radioInput}
                data-testid={renderAltText(index)}
                aria-describedby={props.questionId + "-error"}
              />
              <img
                className={s.imgStyle}
                id={`${index}-${extractContent(
                  props.question.replace(/\s+/g, "")
                )}`}
                onClick={() => handleChangeFace(index)}
                src={val}
                style={{ width: index === value ? 60 : 40 }}
              />
            </label>
          ))}
        </div>
        <div className={s.labels}>
          <span className={s.maxLabel}>
            {" "}
            {getTranslation(
              props.currentLang,
              "surveyTaker:stronglyDissatisfied"
            )}
          </span>
          <span className={s.maxLabel}>
            {" "}
            {getTranslation(props.currentLang, "surveyTaker:stronglySatisfied")}
          </span>
        </div>
      </fieldset>
    </div>
  );
};

AnswerSatisfactionFaces.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

AnswerSatisfactionFaces.defaultProps = {
  handleChange: () => {},
  required: false,
};

export default AnswerSatisfactionFaces;
